/** Native boundary shared by forms and overlays, including external action bars. */
export const CANCEL_EVENT = 'ui:request-form-cancel';
export function requestFormCancel(formId: string, onCancel: () => void) {
  const node = document.getElementById(formId);
  if (node instanceof HTMLFormElement) node.dispatchEvent(new CustomEvent(CANCEL_EVENT, { detail: onCancel }));
}
